module.exports = __webpack_public_path__ + "assets/images/declineOMsuccess.ef491.png";